// @flow

import React, {useState} from 'react';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {Grid, Typography, makeStyles, useMediaQuery} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';

import type {
  ProductVariantOption,
  ProductVariantOptionValue,
} from '../../../../entities';
import {getImageUrl} from '../../../../utils/image_provider';
import {MAX_OPTION_VALUES_TO_SHOW} from './VariantItem';

type Props = {
  variantOption: ProductVariantOption,
};

const useStyles = makeStyles(theme => ({
  btn: {
    color: colors.grey800,
    borderRadius: 10,
    background: colors.grey200,
  },
  modal: {
    width: 460,
    maxWidth: '90%',
  },
  title: {
    color: '#313135',
    fontSize: 20,
    textAlign: 'center',
    fontWeight: 600,
  },
  content: {
    margin: theme.spacing(1.5, 0),
    padding: theme.spacing(2),
    border: `1px solid ${colors.grey300}`,
    borderRadius: 12,
    maxHeight: 600,
    overflow: 'auto',
  },
  valueName: {
    fontSize: 14,
    color: colors.grey900,
  },
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
    width: '100%',
    height: '100%',
  },
  value: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
}));

const VariantItemPreviewModal = ({variantOption}: Props) => {
  const classes = useStyles();
  const mobile = useMediaQuery('(max-width:960px)');
  const [showModal, setShowModal] = useState();

  const buildValuePreview = (value: ProductVariantOptionValue) => {
    const isColor = variantOption.displayType === 'COLOR';
    const isImage = variantOption.imageShape === 'IMAGE';

    const style = {
      width: 24,
      height: 24,
      borderRadius:
        variantOption.imageShape === 'CIRCULAR' ? '100%' : undefined,
      backgroundColor: isColor ? value.color : undefined,
    };

    return (
      <div style={style}>
        {isImage && (
          <img
            className={classes.img}
            src={getImageUrl(value.imageId)}
            alt=""
          />
        )}
      </div>
    );
  };

  return (
    <>
      {variantOption.values.length > MAX_OPTION_VALUES_TO_SHOW && (
        <CustomButton
          fullWidth={mobile ? true : false}
          className={classes.btn}
          onClick={() => setShowModal(true)}
        >
          Ver todas
        </CustomButton>
      )}

      <CustomModal
        open={showModal}
        handleCloseModal={() => setShowModal(false)}
      >
        <div className={classes.modal}>
          <Typography className={classes.title}>
            {variantOption.label}
          </Typography>

          <div className={classes.content}>
            <Grid container spacing={2}>
              {variantOption.values.map(el => (
                <Grid item xs={12} md={6} key={el.id}>
                  <div className={classes.value}>
                    {buildValuePreview(el)}
                    <Typography className={classes.valueName}>
                      {el.label}
                    </Typography>
                  </div>
                </Grid>
              ))}
            </Grid>
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CustomButton
              variant="contained"
              style={{width: '15rem'}}
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </CustomButton>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default VariantItemPreviewModal;
